import { initialValuesAmenity as initialValues } from '../../../../../../helpers/variablesInitialValues';
import * as types from '../types/amenityType';

/**
 *
 * @description Set reset amenity state
 * @return dispatch
 *
 */
export const setAmenityReset = () => (
	async (dispatch) => {
		await dispatch( setPerPage(10) );
		await dispatch( setPage(1) );
		await dispatch( setPages(1) );
		await dispatch( setSearch('') );
		await dispatch( setArrayList([]) );
		await dispatch( setArrayListToDropdownCommercialArea([]) );
		await dispatch( setArrayListToDropdownLegalArea([]) );
		await dispatch( setArrayListToDropdownCommercialBuilding([]) );
		await dispatch( setRefreshTable(false) );
		await dispatch( setIsOpenModal(false) );
		await dispatch( setIsLoadingShow(false) );
		await dispatch( setIsLoadingForm(false) );
		await dispatch( setFormType('') );
		await dispatch( setFormData(initialValues) );
	}
);

/**
 *
 * @description Set perPage state
 * @param value
 * @return object
 *
 */
export const setPerPage = value => ({
	type: types.PER_PAGE_AMENITY,
	payload: value
});

/**
 *
 * @description Set page state
 * @param value
 * @return object
 *
 */
export const setPage = value => ({
	type: types.PAGE_AMENITY,
	payload: value
});

/**
 *
 * @description Set pages state
 * @param value
 * @return object
 *
 */
export const setPages = value => ({
	type: types.PAGES_AMENITY,
	payload: value
});

/**
 *
 * @description Set search state
 * @param value
 * @return object
 *
 */
export const setSearch = value => ({
	type: types.SEARCH_AMENITY,
	payload: value
});

/**
 *
 * @description Set arrayList state
 * @param value
 * @return object
 *
 */
export const setArrayList = value => ({
	type: types.ARRAY_LIST_AMENITY,
	payload: value
});

/**
 *
 * @description Set arrayListDropdownCommercialArea state
 * @param value
 * @return object
 *
 */
export const setArrayListToDropdownCommercialArea = value => ({
	type: types.ARRAY_LIST_TO_DROPDOWN_COMMERCIAL_AREA_AMENITY,
	payload: value
});

/**
 *
 * @description Set arrayListDropdownLegalArea state
 * @param value
 * @return object
 *
 */
export const setArrayListToDropdownLegalArea = value => ({
	type: types.ARRAY_LIST_TO_DROPDOWN_LEGAL_AREA_AMENITY,
	payload: value
});

/**
 *
 * @description Set arrayListDropdownLegalArea state
 * @param value
 * @return object
 *
 */
export const setArrayListToDropdownCommercialBuilding = value => ({
	type: types.ARRAY_LIST_TO_DROPDOWN_COMMERCIAL_BUILDING_AMENITY,
	payload: value
});

/**
 *
 * @description Set refreshTable state
 * @param value
 * @return object
 *
 */
export const setRefreshTable = value => ({
	type: types.REFRESH_TABLE_AMENITY,
	payload: value
});

/**
 *
 * @description Set isOpenModal state
 * @param value
 * @return object
 *
 */
export const setIsOpenModal = value => ({
	type: types.IS_OPEN_MODAL_AMENITY,
	payload: value
});

/**
 *
 * @description Set isLoadingShow state
 * @param value
 * @return object
 *
 */
export const setIsLoadingShow = value => ({
	type: types.IS_LOADING_SHOW_AMENITY,
	payload: value
});

/**
 *
 * @description Set isLoadingForm state
 * @param value
 * @return object
 *
 */
export const setIsLoadingForm = value => ({
	type: types.IS_LOADING_FORM_AMENITY,
	payload: value
});

/**
 *
 * @description Set formType state
 * @param value
 * @return object
 *
 */
export const setFormType = value => ({
	type: types.FORM_TYPE_AMENITY,
	payload: value
});

/**
 *
 * @description Set formData state
 * @param value
 * @return object
 *
 */
export const setFormData = value => ({
	type: types.FORM_DATA_AMENITY,
	payload: value
});
